import { render } from "./TNovoProjeto.vue?vue&type=template&id=6178c473&scoped=true"
const script = {}

import "./TNovoProjeto.vue?vue&type=style&index=0&id=6178c473&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6178c473"]])

export default __exports__